import React from 'react';
import _ from 'lodash';

import JsonValidator from '../..//lib/JsonValidator';
import { makeRequest, fetchBaseUrl, processResponse } from './AjaxMls';

const Context = React.createContext();

export const AuthenticationMlsProvider = ({ children }) => {
    const authenticate = React.useCallback(async (props) => { 
        const base_url = fetchBaseUrl();

        const payload = {
            email: process.env.REACT_APP_MLSAPI_USER,
            password: process.env.REACT_APP_MLSAPI_PWD
        };

        var response = await makeRequest({ url: `${base_url}/login?email=${payload.email}&password=${payload.password}`, method: 'GET' });
        
        var result = processResponse(response);
        if (result.status === 200) {
            localStorage.setItem('authDataMls', JSON.stringify({
                accessToken: response.body.api_key,
                status: response.body.status
            }));
        }

        return result;
    }, []);

    const login = React.useCallback(() => {
        return authenticate();
    }, []);

    const logout = React.useCallback(() => {
        localStorage.clear();
    }, []);

    const validate = React.useCallback(() => {
        const authDataMls = fetchAuthDataMls();
        let valid = false;
        
        if (!_.isEmpty(authDataMls) && !_.isEmpty(authDataMls.accessToken)) {
            valid = true;
        }
    
        return valid;
    }, []);

    const fetchAuthDataMls = () => {
        // Check to see if they already have authData in the store
        const authObject = localStorage.getItem('authDataMls');
        let valid = (authObject && JsonValidator(authObject)); 

        // If we have auth data, then let's start parsing it
        if (valid) {
            // Parse it and make sure we have the fields we need
            const authData = JSON.parse(authObject);
            valid = (authData['accessToken'] !== undefined );

            // If it's still valid, let's check other stuff in the token
            if (valid) {
                return {
                    accessToken: authData['accessToken']
                };
            };
        }

        return null;
    };

    const value = { fetchAuthDataMls, login, authenticate, logout, validate };

    return (
        <Context.Provider value={value}>
            {children}
        </Context.Provider>
    );
};

export const useAuthenticationMlsStore = () => React.useContext(Context);
